import axios from 'axios';
import { getItem } from '../../utility/localStorageControl';

const API_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}`;

const authHeader = () => ({
  Authorization: `Bearer ${getItem('access_token')}`,
  'Content-Type': 'application/json',
});

export const Client = axios.create({
  baseURL: API_ENDPOINT,
});

class DataService {

  static externalGet(url) {
    return axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  static get(path = '', optionalHeader = {}) {
    return Client({
      method: 'GET',
      url: path,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static publicGet(path = '', optionalHeader = {}) {
    return Client({
      method: 'GET',
      url: path,
      headers: { 'Content-Type': 'application/json', ...optionalHeader },
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return Client({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static publicPost(path = '', data = {}, optionalHeader = {}) {
    return Client({
      method: 'POST',
      url: path,
      data,
      headers: { ...optionalHeader },
    });
  }

  static patch(path = '', data = {}) {
    return Client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return Client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static delete(path = '') {
    return Client({
      method: 'DELETE',
      url: path,
      headers: { ...authHeader() },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
// Client.interceptors.request.use((config) => {
//   // do something before executing the request
//   // For example tag along the bearer access token to request header or set a cookie
//   const requestConfig = config;
//   const { headers } = config;
//   requestConfig.headers = { ...headers, Authorization: `Bearer ${getItem('access_token')}` };

//   return requestConfig;
// });

// Client.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     /**
//      * Do something in case the response returns an error code [3**, 4**, 5**] etc
//      * For example, on token expiration retrieve a new access token, retry a failed request etc
//      */
//     const { response } = error;
//     const originalRequest = error.config;
//     if (response) {
//       if (response.status === 500) {
//         // do something here
//       } else {
//         return originalRequest;
//       }
//     }
//     return Promise.reject(error);
//   },
// );
export { DataService };
